import { styled } from '@mui/material';

import {
  StarBorderSmallIcon,
  StarFullSmallIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
} from '@app-velocity/icons';
import { Box } from '@app-velocity/ui';

import { TPrototypeReviewDto } from '@app-velocity/av-api-v2';

import { useReviewContext } from '../../hooks/useReviewContext';

const IconContainer = styled(Box)<{ vote: TPrototypeReviewDto['vote'] }>(
  ({ vote }) => ({
    svg: {
      fill:
        vote === 'UP'
          ? 'var(--success-success-icon-primary-color)'
          : 'var(--error-error-icon-primary-color)',
    },
  })
);

export const Rating = () => {
  const { review } = useReviewContext();
  const { rating, vote } = review;

  if (vote) {
    return (
      <IconContainer vote={vote}>
        {vote === 'UP' ? <ThumbsUpIcon /> : <ThumbsDownIcon />}
      </IconContainer>
    );
  }

  // fallback
  if (rating) {
    return (
      <Box>
        {[1, 2, 3, 4, 5].map((val) =>
          (rating || 0) >= val ? (
            <StarFullSmallIcon key={val} />
          ) : (
            <StarBorderSmallIcon key={val} />
          )
        )}
      </Box>
    );
  }

  return null;
};
